// Environment Configuration
export interface EnvironmentConfig {
  isProduction: boolean
  isDevelopment: boolean
  appUrl: string
  landingPageUrl: string
  apiUrl: string
  environment: 'development' | 'production' | 'staging'
}

// Get current environment
const getEnvironment = (): EnvironmentConfig => {
  const hostname = window.location.hostname
  const protocol = window.location.protocol
  const port = window.location.port
  
  // Check for production domains
  const isProduction = hostname === 'oilbuddy.ai' || hostname === 'oilbuddy.ai'
  const isStaging = hostname === 'staging.oilbuddy.ai'
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1'

  if (isProduction) {
    return {
      isProduction: true,
      isDevelopment: false,
      appUrl: `${protocol}//${hostname}${port ? ':' + port : ''}`,
      landingPageUrl: `${protocol}//${hostname}${port ? ':' + port : ''}`,
      apiUrl: `${protocol}//${hostname}${port ? ':' + port : ''}/api`,
      environment: 'production'
    }
  }

  if (isStaging) {
    return {
      isProduction: false,
      isDevelopment: false,
      appUrl: `${protocol}//${hostname}${port ? ':' + port : ''}`,
      landingPageUrl: `${protocol}//${hostname}${port ? ':' + port : ''}`,
      apiUrl: `${protocol}//${hostname}${port ? ':' + port : ''}/api`,
      environment: 'staging'
    }
  }

  // Development environment - use Vite proxy for localhost
  return {
    isProduction: false,
    isDevelopment: true,
    appUrl: isLocalhost ? 'http://localhost:3000' : `${protocol}//${hostname}${port ? ':' + port : ''}`,
    landingPageUrl: isLocalhost ? 'http://localhost:3000' : `${protocol}//${hostname}${port ? ':' + port : ''}`,
    apiUrl: isLocalhost ? '/api' : `${protocol}//${hostname}${port ? ':' + port : ''}/api`,
    environment: 'development'
  }
}

export const env = getEnvironment()

// Helper functions
export const getLandingPageUrl = (): string => {
  return env.landingPageUrl
}

export const getApiUrl = (): string => {
  return env.apiUrl
}

export const isProduction = (): boolean => {
  return env.isProduction
}

export const isDevelopment = (): boolean => {
  return env.isDevelopment
}
